export const isValidEmail = (email) => {
  if (typeof email !== "string") return false;
  const normalized = email.trim();
  return (
    normalized.length <= 254 &&
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized)
  );
};

export const isValidPassword = (password) => {
  if (typeof password !== "string") return false;
  const length = Array.from(password).length;
  return (
    length >= 8 &&
    length <= 55 &&
    new TextEncoder().encode(password).length <= 72 &&
    /\p{L}/u.test(password) &&
    /\p{N}/u.test(password)
  );
};
